import DateFnsUtils from '@date-io/date-fns';
import { Tooltip } from '@material-ui/core';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React, { FC } from 'react';

export interface DatePickerProps {
  label: string;
  value: Date | null;
  format?: string;
  disabled?: boolean;
  onChange?: (newdate: Date | null) => void;
  tooltip?: string;
  disablePast?: boolean;
  minDate?: Date;
  maxDate?: Date;
  mandatory?: boolean;
  style?: React.CSSProperties;
  error?: boolean;
  helperText?: string;
}

const DatePicker: FC<DatePickerProps> = (props) => {
  const handleChange = (date: Date | null) => {
    // Only call onChange if date is valid or null
    if (date === null || (date instanceof Date && !Number.isNaN(date.getTime()))) {
      if (props.onChange) {
        props.onChange(date);
      }
    }
    // If invalid date, don't call onChange - let the component handle the error state
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        // disableToolbar
        variant="inline"
        label={props.label}
        required={props.mandatory}
        format={props.format ?? 'dd/MM/yyyy'}
        value={props.value}
        onChange={handleChange}
        disablePast={props.disablePast ?? true}
        minDate={props.minDate}
        maxDate={props.maxDate}
        disabled={props.disabled}
        style={props.style}
        error={props.error}
        helperText={props.helperText}
        invalidDateMessage="Invalid date format"
        maxDateMessage="Date must be before maximum date"
        minDateMessage="Date must be after minimum date"
        inputProps={{
          style: {
            fontSize: '1vw',
            paddingTop: 5,
            marginRight: -20,
            marginLeft: -1,
            marginTop: 5,
          },
        }}
        InputLabelProps={{
          shrink: true,
        }}
        keyboardIcon={
          <Tooltip title={props.tooltip} placement="right">
            <CalendarIcon fontSize="small" style={{ margin: -35 }} />
          </Tooltip>
        }
      />
    </MuiPickersUtilsProvider>
  );
};

export default React.memo(DatePicker);
